import { useContext } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Context as ResetContext } from '@/context/ResetPaswdContext.js';

// For a patient whose sign-up code was just accepted but whose password doesn't match: the code verified the email,
// so a reset code can be sent and the reset flow opened at its code step.
export const useStartPasswordReset = () => {
    const history = useHistory();
    const { t } = useTranslation();
    const { setEmailField, sendResetEmail } = useContext(ResetContext);

    return async (email) => {
        setEmailField(email);
        if (await sendResetEmail(email, history)) {
            toast(t('PasswordResetAfterConfirmation'));
            return;
        }
        history.push('/reset-password');
    };
};
